import { combineReducers } from "redux";
import notification from "../features/admin/pushnotification/notification/Slice";




const pushnotification = combineReducers({
   notification: notification,
  
  });
  
  export default pushnotification;